import { render, staticRenderFns } from "./SideStockHead.vue?vue&type=template&id=f83af888&scoped=true"
import script from "./SideStockHead.vue?vue&type=script&lang=js"
export * from "./SideStockHead.vue?vue&type=script&lang=js"
import style0 from "./SideStockHead.vue?vue&type=style&index=0&id=f83af888&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83af888",
  null
  
)

export default component.exports